import * as Sentry from "@sentry/react";
import { FirebaseError } from "firebase/app";
import { useCallback, useRef } from "react";
import parseFirebaseError from "src/pages/parseFirebaseError";
import { useSnackbarContext } from "../../SnackbarProvider";

export default function useErrorHandler(): (e: unknown) => void {
  const snackbarContext = useSnackbarContext();
  const snackbarRef = useRef(snackbarContext);
  snackbarRef.current = snackbarContext;

  const handleError = useCallback(
    (e: unknown) => {
      // eslint-disable-next-line no-console
      if (process.env.NODE_ENV === "development") console.error(e);
      if (!(e instanceof Error)) return;
      if (e instanceof FirebaseError) {
        Sentry.captureException(e);
        snackbarRef.current.alert("error", parseFirebaseError(e));
        return;
      }
      Sentry.captureException(e);
      snackbarRef.current.alert("error", e.message);
    },
    [] // Remove snackbarContext from dependencies
  );

  return handleError;
}
